export default {
  FETCH_EVENTS: ({ }, { }) => {
    data = {
      results: [
        {
          _id: 1,
          title: 'יוסי כהן, נפאל',
          clients: [
            {
              name: 'יוסי כהן',
              image: 'https://randomuser.me/api/portraits/men/82.jpg'
            },
            {
              name: 'אבי לוי',
              image: 'https://randomuser.me/api/portraits/men/84.jpg'
            }
          ],
          status: 'CLOSED',
          type: {
            _id: 2,
            title: 'איתור'
          },
          countries: ['נפאל', 'הודו'],
          managers: [{
            _id: 1,
            name: 'נווה לב',
            image: 'https://randomuser.me/api/portraits/man/81.jpg',
            startDate: subHours(new Date(), 8)
          }],
          startDate: subHours(new Date(), 8)
        },
        {
          _id: 1,
          title: 'יוסי כהן, נפאל',
          clients: [
            {
              name: 'יוסי כהן',
              image: 'https://randomuser.me/api/portraits/men/82.jpg'
            },
            {
              name: 'אבי לוי',
              image: 'https://randomuser.me/api/portraits/men/84.jpg'
            }
          ],
          status: 'CLOSED',
          type: {
            _id: 2,
            title: 'איתור'
          },
          countries: ['נפאל', 'הודו'],
          managers: [{
            _id: 1,
            name: 'נווה לב',
            image: 'https://randomuser.me/api/portraits/man/81.jpg',
            startDate: subHours(new Date(), 8)
          }],
          startDate: subHours(new Date(), 8)
        },
        {
          _id: 1,
          title: 'יוסי כהן, נפאל',
          clients: [
            {
              name: 'יוסי כהן',
              image: 'https://randomuser.me/api/portraits/men/82.jpg'
            },
            {
              name: 'אבי לוי',
              image: 'https://randomuser.me/api/portraits/men/84.jpg'
            }
          ],
          status: 'CLOSED',
          type: {
            _id: 2,
            title: 'איתור'
          },
          countries: ['נפאל', 'הודו'],
          managers: [{
            _id: 1,
            name: 'נווה לב',
            image: 'https://randomuser.me/api/portraits/man/81.jpg',
            startDate: subHours(new Date(), 8)
          }],
          startDate: subHours(new Date(), 8)
        }
      ],
      totalResults: 12
    };
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(data);
      }, 500);
    });
  }
};


// WEBPACK FOOTER //
// ./src/store/events/actions.js